import React from 'react';
import { useSearchParams } from 'react-router-dom';

export const DONEE_SEARCH_QUERY_NAME = 'donee';

export const getDoneeIdFromQuery = (searchParams: URLSearchParams) => {
    const doneeQuery = searchParams.get(DONEE_SEARCH_QUERY_NAME);
    if (!doneeQuery) return;

    const doneeIdRaw = parseInt(doneeQuery);
    if (isNaN(doneeIdRaw)) return;

    return doneeIdRaw;
};

export const useDoneeIdFromQuery = () => {
    const [searchParams] = useSearchParams();
    const doneeIdFromQuery = React.useMemo(
        () => getDoneeIdFromQuery(searchParams),
        [searchParams],
    );

    return doneeIdFromQuery;
};
